import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { GET_UPLOAD_SIGNED_URL } from 'root/src/shared/descriptions/endpoints/endpointIds'
import ajax from 'root/src/shared/util/ajax'
import outputs from 'root/cfOutput'

const { domainName } = outputs

export default async (file, dispatch, minutesTtl) => {
	const payload = {
		fileName: file.name,
		minutesTtl,
	}
	const { body } = await dispatch(apiRequest(GET_UPLOAD_SIGNED_URL, payload))
	const { signedUrl, contentType, fileName, expires } = body
	await ajax({
		url: signedUrl,
		method: 'PUT',
		file,
		headers: {
			'Content-Type': contentType,
			...(minutesTtl ? {
				'x-amz-tagging': 'removeAfterExpiration=true',
				expires,
			} : {}),
		},
	})

	return `${domainName}/files/${fileName}`
}
